var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (quotes) {pug_html = pug_html + "\u003Csection class=\"quotes\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"quotes__slider\"\u003E";
// iterate quotes
;(function(){
  var $$obj = quotes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cimg" + (" class=\"quote-logo\""+pug.attr("src", item.logo, true, true)+pug.attr("alt", item.author, true, true)) + "\u003E\u003Cp class=\"quote\"\u003E\"" + (pug.escape(null == (pug_interp = item.quote) ? "" : pug_interp)) + "\"\u003C\u002Fp\u003E\u003Cp class=\"author\"\u003E\u003Cb\u003E" + (pug.escape(null == (pug_interp = item.author) ? "" : pug_interp)) + "\u003C\u002Fb\u003E " + (pug.escape(null == (pug_interp = item.autorTitle) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cimg" + (" class=\"quote-logo\""+pug.attr("src", item.logo, true, true)+pug.attr("alt", item.author, true, true)) + "\u003E\u003Cp class=\"quote\"\u003E\"" + (pug.escape(null == (pug_interp = item.quote) ? "" : pug_interp)) + "\"\u003C\u002Fp\u003E\u003Cp class=\"author\"\u003E\u003Cb\u003E" + (pug.escape(null == (pug_interp = item.author) ? "" : pug_interp)) + "\u003C\u002Fb\u003E " + (pug.escape(null == (pug_interp = item.autorTitle) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"quotes" in locals_for_with?locals_for_with.quotes:typeof quotes!=="undefined"?quotes:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/partials/quotes.pug
// module id = 1186
// module chunks = 0